import Button from '../../../../sharedComponents/Button/Button';
import SystemWarning from '../../../../../assets/Icons/SystemWarning';

import { ThemedView, ThemedPressable, ThemedText } from '@app/theme';
const ConfirmEditLimit = ({
  ctaAction1 = () => {},
  ctaAction2 = () => {},
  onClose = () => {},
  buttonLoader = false,
}) => {
  return (
    <ThemedView p="lg" mt="sm">
      <ThemedView flexDirection='row' justifyContent='center'>
        <SystemWarning />
      </ThemedView>

      <ThemedView my="2xl">
            <ThemedText mt={"2xl"} variant={"h5s"} mb={"2xl"} textAlign={"center"} color={'text-primary'}>
                Are you sure you want to edit your limit? This will reset your selected limit.
            </ThemedText>
      </ThemedView>
      <ThemedView mb="md">
        <Button
          eventName='DASHBOARD_EDIT_LIMIT_YES_CLICKED'
          label={'Yes, continue to edit limit'}
          type={'SOLID'}
          handlePress={ctaAction1}
          size={'MD'}
          buttonLoader={buttonLoader}
        />
      </ThemedView>
      <Button
        eventName='DASHBOARD_EDIT_LIMIT_NO_CLICKED'
        label={'No, continue with selected limit'}
        type={'OUTLINED'}
        handlePress={ctaAction2}
        size={'MD'}
      />
    </ThemedView>
  );
};

export default ConfirmEditLimit;
